import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import AccountCreation, {
    Separator
} from "@/components/signup/account-creation";

import { NoCreditCardRequired } from "../../../components";
import { BlueWaveTemplateJsm } from "../../components";

export const LoggedOutBlueWaveTemplateJsm = ({
    productEditionText
}: {
    productEditionText: string;
}) => {
    const { formatMessage } = useIntl();

    return (
        <BlueWaveTemplateJsm productEditionText={productEditionText}>
            <div>
                <h2 css={accountCreationHeadingCss}>
                    {formatMessage({
                        id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading",
                        defaultMessage: "Start now"
                    })}
                </h2>
                <p css={accountCreationSubHeadingCss}>
                    {formatMessage({
                        id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard",
                        defaultMessage:
                            "7-day free trial for up to 10,000 users"
                    })}
                </p>
            </div>
            <div css={spacingCss}>
                <AccountCreation
                    Login={null}
                    Separator={
                        <>
                            <NoCreditCardRequired />
                            <Separator
                                separatorText={formatMessage({
                                    id: "WacSignupForm.socialSignUpOrSignUpWith",
                                    defaultMessage: "Or sign up with"
                                })}
                            />
                        </>
                    }
                />
            </div>
        </BlueWaveTemplateJsm>
    );
};

const accountCreationHeadingCss = css({
    fontSize: 36,
    fontWeight: 500,
    margin: 0,
    textAlign: "center"
});

const accountCreationSubHeadingCss = css({
    margin: 0,
    textAlign: "center"
});

const spacingCss = css({
    paddingBlockEnd: "68px"
});
